// 确保 async/await 支持（CDN 版本可能不包含）
import "regenerator-runtime/runtime";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";
import locale from 'antd/locale/zh_CN';
import dayjs from 'dayjs';

import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');
// 仅在test模式下初始化vconsole
// if (process.env.REACT_APP_ENV !== "production") {
//   const VConsole = require("vconsole");
//   new VConsole();
// }

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,      // 5 分钟内数据视为新鲜
      gcTime: 10 * 60 * 1000,        // 缓存保留 10 分钟 (原 cacheTime)
      retry: 1,                       // 失败重试 1 次
      refetchOnWindowFocus: false,    // 窗口聚焦时不重新请求
    },
  },
});

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename="/">
      <ConfigProvider locale={locale}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
